import React from "react";
import  MultiSelectReact  from 'multi-select-react';

export default class Selectmultiple extends React.Component {
    constructor(props) {
        super(props);
        this.state = {multiSelect: [], opciones:[]}
        this.clicAlgo = this.clicAlgo.bind(this);
    }

    optionClicked(optionsList) {
        this.clicAlgo(optionsList);
    }

    selectedBadgeClicked(optionsList) {
        this.clicAlgo(optionsList);
    }

    clicAlgo(opciones){
        var opcs = opciones.filter(o => o.value === true),
            arr = new Object();
        arr.nombre = this.props.nombre;
        arr.datos = opcs;
        this.props.action(arr);
        opciones.forEach((o)=>{
            o.nuevo = false;
        });
        this.setState({ multiSelect: opciones });
    }

    render() {
        const selectedOptionsStyles = { color: "#763c3c", backgroundColor: "#f0d8d8", 'fontSize': '0.6rem' };
        const optionsListStyles = { backgroundColor: "#f0d8d8", color: "#763c3c", 'fontSize': '0.8rem' };

        return (
        <MultiSelectReact 
        options={(this.props.datos.length === this.state.multiSelect.length ? this.state.multiSelect : this.props.datos)}
        optionClicked={this.optionClicked.bind(this)}
        selectedBadgeClicked={this.selectedBadgeClicked.bind(this)}
        selectedOptionsStyles={selectedOptionsStyles}
        optionsListStyles={optionsListStyles} 
        isSingleSelect={this.props.sencillo}
        />
        );
    }
}